import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';

import { Button } from 'design-system-web';
import { routes } from 'client-config';

import { CostOffsetCodeTable } from '../costOffsetCodes/CostOffsetCodeTable';
import styles from '../styles.scss';

type Props = {
  formRoute?: string;
  canManage?: boolean;
};

export function CostOffsetCodesTab({ formRoute, canManage = true }: Props) {
  const { t } = useTranslation();
  const { id }: { id: string } = useParams();
  const history = useHistory();

  const handleCreateCostOffsetCode = () => {
    history.push(
      formRoute ??
        routes.channelAdminCreateCostOffsetCodeForm.replace(':id', id)
    );
  };

  return (
    <>
      <div className={styles.heading}>
        {canManage && (
          <Button
            testId="createCostOffsetCode"
            variant="primary"
            size="large"
            onClick={handleCreateCostOffsetCode}
          >
            {t('abp.productsServices.costOffsetCodes.button')}
          </Button>
        )}
      </div>
      <CostOffsetCodeTable />
    </>
  );
}
